export type SnakeCase<S extends string> = S extends `${infer C0}${infer R}`
  ? R extends Uncapitalize<R>
    ? `${Lowercase<C0>}${SnakeCase<R>}`
    : `${Lowercase<C0>}_${SnakeCase<R>}`
  : S

export const toSnakeCase = (str: string): string =>
  str
    // Insert _ before any uppercase character that follows a lowercase or number
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    // Insert _ between consecutive uppercase letters and a following lowercase letter (e.g., XMLHttpRequest -> XML_HttpRequest)
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2")
    // Remove leading underscores if present
    .replace(/^_+/, "")
    .toLowerCase()
